import { useRef } from 'react';
import { TableSelectionRef } from './types';

export const useTableSelectionRef = () => {
  const tableSelectionPanelRef = useRef<HTMLDivElement>(null);

  const tableSelectionStateRef = useRef<TableSelectionRef>({
    selectedRowIds: [],
    toggleSelection: () => {},
  });

  const resetSelection = () => {
    tableSelectionStateRef?.current?.toggleSelection({
      rowIds: tableSelectionStateRef?.current?.selectedRowIds || [],
    });
  };

  return {
    tableSelectionStateRef,
    tableSelectionPanelRef,
    resetSelection,
  };
};
